
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AutoReplyInfo": [
      "LiveCommentAutoReplyInfo"
    ],
    "AutomationFlowContent": [
      "AutomationTemplateContent",
      "AutomationTextContent"
    ],
    "AutomationFlowTrigger": [
      "AnyContent",
      "ContainsKeyword"
    ],
    "ChatAssignee": [
      "ChatAIAssignee",
      "ChatUserAssignee"
    ],
    "ChatShopeeDiscount": [
      "ChatShopeeCoinCashBack",
      "ChatShopeeFixedDiscount",
      "ChatShopeePercentageDiscount"
    ],
    "CommonChatEventData": [
      "AIMessageFailedToSendEvent",
      "ActivateAI",
      "AddUserToAssigneeList",
      "CloseChat",
      "DeactivateAI",
      "ManualAssign",
      "ManualUnassign",
      "MessageSendFailedEvent",
      "MuteChat",
      "RemoveUserFromAssigneeList",
      "ReopenChat",
      "SystemAutoAssignAI",
      "SystemAutoUnassignAI",
      "UnmuteChat"
    ],
    "ConnectLazadaResponse": [
      "ConnectLazadaResponseSuccess",
      "UnknownErrorConnectLazadaError"
    ],
    "ConnectShopeeChatResponse": [
      "ConnectShopeeChatContinueSelectShopResponse",
      "ConnectShopeeChatSuccessResponse"
    ],
    "ConnectToFacebookResponseV2": [
      "AccountAlreadyHaveConnection",
      "ConnectToFacebookResponseSuccess",
      "MessengerNotSupportChatPlugInWithAnonymousUserFacebookError",
      "NoInstagramAccountConnectToFacebookError",
      "PageHaveConnectedToOtherStore",
      "UnknownErrorConnectToFacebookError"
    ],
    "ConnectToWhatsAppResponse": [
      "ConnectToWhatsAppAccountAlreadyHaveConnection",
      "ConnectToWhatsAppResponseSuccess",
      "UnknownErrorConnectToWhatsAppError"
    ],
    "CourierDetails": [
      "DHLAccountDetails",
      "FedExAccountDetails",
      "JapanPostAccountDetails",
      "UPSAccountDetails"
    ],
    "CrossBorderServiceCode": [
      "DHLServiceCodeWrapper",
      "FedExServiceCodeWrapper",
      "JapanPostServiceCodeWrapper",
      "UPSServiceCodeWrapper"
    ],
    "CustomerActivityV4": [
      "CustomerCreatedActivityV4",
      "InfluencerJoinedCampaignActivityV4",
      "InfluencerPublishedPostActivityV4",
      "InfluencerSubmittedPostActivityV4",
      "OptInActivityV4",
      "OrderedActivityV4",
      "ProfileUpdatedActivityV4"
    ],
    "CustomerCreatedChannel": [
      "CustomerCreatedMessagingChannel",
      "CustomerCreatedSaleChannel"
    ],
    "CustomerTagDeleteResponse": [
      "CustomerTagDeleteFailure",
      "CustomerTagDeleteSuccess"
    ],
    "DeliveryTiming": [
      "Immediately",
      "Schedule"
    ],
    "FailedMessageContent": [
      "FailedMessageFileContent",
      "FailedMessageImageContent",
      "FailedMessageTextContent",
      "FailedMessageVideoContent"
    ],
    "InstagramChatEvent": [
      "CommonChatEvent",
      "InstagramMessageEvent"
    ],
    "InstagramMessage": [
      "InstagramBotAutoReplyMessage",
      "InstagramBotAutoReplyMessageDelete",
      "InstagramBotMessage",
      "InstagramBotMessageDeleted",
      "InstagramUserMessage",
      "InstagramUserMessageDeleted"
    ],
    "InstagramMessageContent": [
      "AutoReplyContent",
      "ImageMessageContent",
      "StoryMentionContent",
      "TextLiveCommentContent",
      "TextMessageContent",
      "UnsupportedContent",
      "VideoMessageContent"
    ],
    "InstagramReaction": [
      "BotReaction",
      "UserReaction"
    ],
    "LazadaChatEvent": [
      "CommonChatEvent",
      "LazadaMessageEvent"
    ],
    "LazadaMessage": [
      "LazadaStoreCSMessage",
      "LazadaUserMessage"
    ],
    "LazadaMessageAuthor": [
      "BasicUser",
      "LazadaFAQBot",
      "RepliedFromLazada"
    ],
    "LazadaMessageContent": [
      "LazadaEmojiMessageContent",
      "LazadaFAQMessageContent",
      "LazadaImageMessageContent",
      "LazadaItemMessageContent",
      "LazadaOrderMessageContent",
      "LazadaTextMessageContent",
      "LazadaUnsupportedMessageContent",
      "LazadaVideoMessageContent",
      "LazadaVoucherMessageContent"
    ],
    "LazadaVoucherDiscount": [
      "LazadaVoucherMoneyValueOff",
      "LazadaVoucherPercentageDiscountOff"
    ],
    "LineCardButtonAction": [
      "ClipboardAction",
      "LinkedPostbackAction",
      "UrlAction",
      "UrlVariableAction"
    ],
    "LineChatEvent": [
      "CommonChatEvent",
      "LinePlatformEvent"
    ],
    "LineMessage": [
      "ButtonMessage",
      "FileMessage",
      "ImageMessage",
      "PlainTextMessage",
      "RichMessage",
      "SingleImageMessage",
      "VideoMessage"
    ],
    "LinePlatformEventContent": [
      "LineBotGreetingMessageEvent",
      "LineBotImageMessageEvent",
      "LineBotTextMessageEvent",
      "LineBotUnitMessageEvent",
      "LineInfluencerJoinedCampaignEvent",
      "LineInquiryEvent",
      "LineInquiryFinishEvent",
      "LineMessageTemplateEvent",
      "LineStateUpdateEvent",
      "LineSystemFoundFollowerEvent",
      "LineUserAudioMessageEvent",
      "LineUserFileMessageEvent",
      "LineUserFollowedEvent",
      "LineUserImageMessageEvent",
      "LineUserLocationMessageEvent",
      "LineUserPostbackEvent",
      "LineUserStickerMessageEvent",
      "LineUserTextMessageEvent",
      "LineUserUnFollowedEvent",
      "LineUserUnsentMessageEvent",
      "LineUserVideoMessageEvent"
    ],
    "LineRichMenuAction": [
      "LineRichMenuMessageAction",
      "LineRichMenuPostbackAction",
      "LineRichMenuUriAction"
    ],
    "LineRichMenuSubmitResponse": [
      "LineRichMenuSubmitFailExistPermanent",
      "LineRichMenuSubmitFailOverlap",
      "LineRichMenuSubmitSuccess"
    ],
    "LineRichMenuUpdateResponse": [
      "LineRichMenuUpdateFailExistPermanent",
      "LineRichMenuUpdateFailOverlap",
      "LineRichMenuUpdateSuccess"
    ],
    "LineStickerData": [
      "AnimatedSticker",
      "OtherSticker",
      "StaticSticker"
    ],
    "LineUrlAction": [
      "LineUrlText",
      "LineUrlVariable"
    ],
    "ListMeta": [
      "MdAccounts",
      "MdStores",
      "MdUsers"
    ],
    "LivestreamSessionPlatformConfigOutput": [
      "BytePlus",
      "Custom",
      "Facebook",
      "Shopee",
      "Tiktok"
    ],
    "MessageAuthor": [
      "AIAuthor",
      "AutoAuthor",
      "BasicUser"
    ],
    "MessengerBroadcastRecipient": [
      "All",
      "CustomerTagName"
    ],
    "MessengerChatEvent": [
      "CommonChatEvent",
      "MessengerMessageEvent"
    ],
    "MessengerContent": [
      "MessengerTemplateContent",
      "MessengerTextContent"
    ],
    "MessengerMessage": [
      "MessengerBotAutoMessage",
      "MessengerBotAutoMessageDeleted",
      "MessengerBotMessage",
      "MessengerBotMessageDeleted",
      "MessengerUserMessage",
      "MessengerUserMessageDeleted"
    ],
    "MessengerMessageContent": [
      "MessengerImageCommentContent",
      "MessengerImageMessageContent",
      "MessengerOptInContent",
      "MessengerOptOutContent",
      "MessengerPostOnPageContent",
      "MessengerRequestOptInContent",
      "MessengerResumeOptInContent",
      "MessengerTextCommentContent",
      "MessengerTextMessageContent",
      "MessengerUnsupportedContent",
      "MessengerVideoMessageContent"
    ],
    "MessengerReaction": [
      "MessengerBotReaction",
      "MessengerUserReaction"
    ],
    "MessengerReactionSign": [
      "MessengerEmoji",
      "MessengerSign"
    ],
    "MessengerReplyTo": [
      "MessengerReplyToMessage"
    ],
    "MetaTokenStatus": [
      "MTS_INVALID_TOKEN",
      "MTS_TOKEN_MISSING_SCOPE",
      "MTS_UNKNOWN",
      "MTS_WORKING"
    ],
    "PackageType": [
      "DHLPackageWrapper",
      "FedExPackageWrapper"
    ],
    "Paginated": [
      "AnylogiOrdersPaginated",
      "AnylogiUsersPaginated",
      "CourierAccountDetailsListResponse",
      "InboundsPaginated",
      "SuppliersPaginated",
      "WarehousesPaginated",
      "getCourierSettingsListResponse",
      "shipperAddressesListResponse"
    ],
    "PaginatedList": [
      "AnyLiveClosingScriptList",
      "AnyLiveFallbackTemplateList",
      "AnyLiveSensitiveWordList",
      "AnyliveIntegrationCredentialList",
      "CommentReplyRecordList",
      "HostList",
      "LiveAssetList",
      "LiveAssetVersionList",
      "LiveStreamList",
      "LivestreamRoomList",
      "ReportExportList",
      "ScriptList",
      "ScriptVersionList",
      "SessionSummaryList",
      "ShopeeCommentList",
      "ShopeeLiveStatList",
      "ShopeeProductList",
      "ShopeeTrendList",
      "StoreConnectionList",
      "TikTokCommentList",
      "TikTokProductList",
      "TikTokTrafficSourceByTimestampGmvList",
      "TikTokTrafficSourceByTimestampValueList",
      "TikTokTrendList"
    ],
    "ProductCSVExportResult": [
      "ProductCSVExportFileResult",
      "ProductCSVExportJobResult"
    ],
    "ProductVariantCSVExportResult": [
      "ProductVariantCSVExportFileResult",
      "ProductVariantCSVExportJobResult"
    ],
    "ReactionSign": [
      "Emoji",
      "InstagramSign"
    ],
    "Recipient": [
      "All",
      "Condition",
      "CustomerTagNames",
      "InfluencerCondition"
    ],
    "RefreshFacebookTokenResponse": [
      "NoInstagramAccountRefreshTokenError",
      "RefreshFacebookTokenResponseSuccess",
      "UnknownErrorRefreshTokenError",
      "WrongPageSelectedRefreshTokenError"
    ],
    "ReplyTo": [
      "ReplyToMessage",
      "ReplyToStory"
    ],
    "SaleChannelData": [
      "AmazonSaleChannelData",
      "EmptySaleChannelData",
      "LazadaSaleChannelData",
      "MomoSaleChannelData",
      "Qoo10SaleChannelData",
      "RakutenSaleChannelData",
      "ShopeeSaleChannelData",
      "ShopifySaleChannelData",
      "TikTokSaleChannelData",
      "TokopediaSaleChannelData",
      "YahooSaleChannelData"
    ],
    "SaleChannelSpecificData": [
      "LazadaSpecificData",
      "ManualsSpecificData",
      "ShopifySpecificData"
    ],
    "SaleChannelSpecificProductData": [
      "ShopifySpecificProductData"
    ],
    "SendMessengerBroadcastResponse": [
      "CompleteSendingMessengerBroadcastSuccess",
      "FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer",
      "StartSendingMessengerBroadcastSuccess"
    ],
    "ShopeeChatEvent": [
      "CommonChatEvent",
      "ShopeeMessageEvent"
    ],
    "ShopeeMessage": [
      "ShopeeAIMessage",
      "ShopeeFAQBotMessage",
      "ShopeeStoreCSMessage",
      "ShopeeUserMessage"
    ],
    "ShopeeMessageContent": [
      "ShopeeFAQBundleContent",
      "ShopeeFAQChoices",
      "ShopeeFAQFeedbackPrompt",
      "ShopeeImageMessageContent",
      "ShopeeImageWithTextMessageContent",
      "ShopeeItemListMessageContent",
      "ShopeeItemMessageContent",
      "ShopeeOrderMessageContent",
      "ShopeeStickerMessageContent",
      "ShopeeTextMessageContent",
      "ShopeeTextMessageContentV2",
      "ShopeeUnsupportedMessageContent",
      "ShopeeVideoMessageContent",
      "ShopeeVoucherMessageContent"
    ],
    "ShopeeMessageSource": [
      "ItemSource",
      "OrderSource"
    ],
    "ShopeeText": [
      "ShopeeNormalText",
      "ShopeeTranslatedText"
    ],
    "SpecificChatPlatformDetail": [
      "InstagramChatPlatformDetail",
      "LazadaChatPlatformDetail",
      "LineChatPlatformDetail",
      "MessengerChatPlatformDetail",
      "ShopeeChatPlatformDetail",
      "TikTokShopChatPlatformDetail",
      "WhatsAppChatPlatformDetail"
    ],
    "StoreChat": [
      "InstagramStoreChat",
      "LazadaStoreChat",
      "LineStoreChat",
      "MessengerStoreChat",
      "ShopeeStoreChat",
      "TikTokShopStoreChat",
      "WhatsAppStoreChat"
    ],
    "UpdateCustomerResponse": [
      "Customer",
      "CustomerGroupProfileUpdateConflictError"
    ],
    "WhatsAppBroadcastActionButton": [
      "WhatsAppBroadcastUrlActionButton"
    ],
    "WhatsAppBroadcastContent": [
      "WhatsAppBroadcastCardContent",
      "WhatsAppBroadcastTextContent"
    ],
    "WhatsAppBroadcastRecipient": [
      "All",
      "WhatsAppRecipientCustomerTagName"
    ],
    "WhatsAppChatEvent": [
      "CommonChatEvent",
      "WhatsAppMessageEvent"
    ],
    "WhatsAppMessage": [
      "WhatsAppAutoReplyMessage",
      "WhatsAppStoreCSMessage",
      "WhatsAppUserMessage"
    ],
    "WhatsAppMessageAutoContent": [
      "WhatsAppOptInRequestMessageContent"
    ],
    "WhatsAppMessageReceivedContent": [
      "WhatsAppImageMessageContent",
      "WhatsAppOptInMessageContent",
      "WhatsAppOptOutMessageContent",
      "WhatsAppTextMessageContent",
      "WhatsAppUnsupportedContent",
      "WhatsAppVideoMessageContent"
    ],
    "WhatsAppMessageSentContent": [
      "WhatsAppImageMessageContent",
      "WhatsAppTextMessageContent",
      "WhatsAppVideoMessageContent"
    ]
  }
};
      export default result;
    